import * as React from 'react';
import Validator from '../../../Helpers/validator';
import Row from '../../../Components/Row';
import Divider from '../../../Components/Divider';
import Select from '../../../Components/Select';
import StringFormatter from '../../../Helpers/StringFormatter';
import Member from '../../Types/Member';
import TextInput from '../../../Components/TextInput';
import { AccountNumberAndSortCodeAPI } from '../../../Helpers/Loqate';
import { IDebitCardDetails } from '../../../Types/Payments/IDebitCardDetails';
import WarningBanner from '../../../Components/WarningBanner';
import ReactHtmlParser from 'html-react-parser';
import SelectDateToDonate from '../../../Components/SelectDateToDonate';
import StartDateInput from '../../../Components/StartDateInput';

enum PaymentFrequency {
  Monthly = 0,
  Quarterly = 1,
  Biannually = 2,
  Annually = 3,
  Once = 4
}

interface DirectDebitConfig {
  originatorsId?: string;
  paymentAppearsAs?: string;
  buttonText?: string;
}

interface Props {
  config: DirectDebitConfig;
  annualPaymentAmountPence: number;
  directDebitDetails: IDebitCardDetails;
  member?: Member;
  footerText?: string;
  buttonClass?: string;
  priceSymbol?: string;
  loqateApiKey?: string;
  useLoqateValidation?: boolean;
  paymentErrorMessage?: string;
  ddMonth?: string;
  ddYear?: string;
  ddType?: string;
  updateDirectDebitDetails(mutate: (dd: IDebitCardDetails) => void): void;
  updateProcessingDisplay(processingMessage?: string): void;
  submit(): void;
  updatepaymentErrorDetail(errorMessage: string, ddMonth: string, ddYear: string): void; 
}

interface State {
  highlightErrors: boolean;
  startDateValid: number;
}

let validStartDate = true;

class DirectDebitPaymentForm extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);

    this.state = {
      highlightErrors: false,
      startDateValid: 0
    };

    if (
      this.props.directDebitDetails.accountHolderName.length === 0 &&
      props.member
    ) {
      const info = props.member.personalInfo;
      const fullName = info.firstName + ' ' + info.lastName;
      this.props.updateDirectDebitDetails(
        dd => (dd.accountHolderName = fullName)
      );
    }
  }

  handleSubmit = async () => {
    this.setState(state => {
      return { ...state, highlightErrors: true };
    });

    if (this.allValid()) {
      if (this.props.useLoqateValidation) {
        const isCorrect = await this.ValidateAccountNumberAndSortCode();
        if (isCorrect) {
          this.props.submit();
        } else {
          // tslint:disable-next-line:max-line-length
          this.props.updatepaymentErrorDetail('Invalid account number or sort code.', this.props.directDebitDetails.startDonationFrom.month, this.props.directDebitDetails.startDonationFrom.year);
        }
      } else {
        this.props.submit();
      }
    }
  };

  allValid = () => {
    let t = this.props.directDebitDetails;
    const nameValid = Validator.isNotEmpty(t.accountHolderName);
    const sortcodeValid = Validator.isSortcode(this.props.directDebitDetails.sortCode);
    const accountnumberValid = Validator.isAccountNumber(this.props.directDebitDetails.accountNumber);
    const dateToDonateValid = Validator.isNotEmpty(t.paymentDay);
    const expValid = Validator.isExpDate(t.startDonationFrom);
    validStartDate = Validator.isValidStartDate(t.paymentDay, t.startDonationFrom);
    const sDateValid = Validator.isValidStartDateMonthAndYear(t.paymentDay, t.startDonationFrom.month, t.startDonationFrom.year);
    
    return nameValid && sortcodeValid && accountnumberValid && dateToDonateValid && expValid && validStartDate && sDateValid;
  }
  
    async ValidateAccountNumberAndSortCode(): Promise<boolean> {
     this.props.updateProcessingDisplay('Validating data');
     let isCorrect = false;
     // tslint:disable-next-line:max-line-length
     let bankApiResponse = await AccountNumberAndSortCodeAPI(this.props.loqateApiKey ? this.props.loqateApiKey : '', this.props.directDebitDetails.accountNumber, this.props.directDebitDetails.sortCode);
     if (bankApiResponse !== undefined) {
     isCorrect = bankApiResponse.IsCorrect ? bankApiResponse.IsCorrect : false;
     this.props.directDebitDetails.bankName = bankApiResponse.Bank ? bankApiResponse.Bank : '';
     this.props.directDebitDetails.branchName = bankApiResponse.Branch ? bankApiResponse.Branch : '';
    }
     this.props.updateProcessingDisplay(undefined);
     return isCorrect;
    }

  renderPaymentFrequencySelect() {
    let options = Object.keys(PaymentFrequency)
      .filter(key => !isNaN(Number(PaymentFrequency[key])))
      .map((value, index) => {
        return (
          <option value={index} key={index}>
            {value}
          </option>
        );
      });

    return (
      
      <div className="input-field">
        <label className="active">Payment Frequency</label>
        <Select
          key={'paymentFrequency'}
          id={'paymentFrequency'}
          value={PaymentFrequency[this.props.directDebitDetails.paymentFrequency]}
          onChange={key =>
            this.props.updateDirectDebitDetails(member => {
              member.paymentFrequency =
                PaymentFrequency[PaymentFrequency[parseInt(key, 10)]];
            })
          }
        >
          {options}
        </Select>
      </div>
    );
  }

  renderPaymentDaySelect() {
    let days: number[] = [];

    for (var i = 0; i < 29; i++) {
      days.push(i);
    }

    let options = days.map((value, index) => {
      let label: string;

      if (value === 0) {
        label = 'Last Day of Month';
      } else {
        label = StringFormatter.numberAsOrdinal(value);
      }

      return (
        <option value={index} key={index}>
          {label}
        </option>
      );
    });

    return (
      <div className="input-field">
        <label className="active">Day of Month (to take payments)</label>
        <Select
          key={'paymentDay'}
          id={'paymentDay'}
          value={this.props.directDebitDetails.paymentDay.toString()}
          onChange={key =>
            this.props.updateDirectDebitDetails(
              member => (member.paymentDay = key)
            )
          }
        >
          {options}
        </Select>
      </div>
    );
  }

  frequencyDivider = () => {
    switch (this.props.directDebitDetails.paymentFrequency) {
      case PaymentFrequency.Annually:
        return 1;
      case PaymentFrequency.Once:
        return 1;
      case PaymentFrequency.Biannually:
        return 2;
      case PaymentFrequency.Quarterly:
        return 4;
      case PaymentFrequency.Monthly:
        return 12;
      default:
        throw 'Frequency does not have a dividing amount';
    }
  };

  render() {
    let pSymbol = '';
    if (this.props.priceSymbol) {
      pSymbol = this.props.priceSymbol;
    }

    let submitBtnClass = 'btn less-padding ';
    if (this.props.buttonClass) {
      submitBtnClass += this.props.buttonClass;
    }

    return (
      <>
        <div className="errorMessage">
        <span>{this.props.paymentErrorMessage}</span>
        </div>
        <TextInput
          key={'accountHolderName'}
          id={'accountHolderName'}
          value={this.props.directDebitDetails.accountHolderName}
          label={'Account Holder Name*'}
          onChange={v => this.props.updateDirectDebitDetails(o => (o.accountHolderName = v))}
          validator={Validator.isNotEmpty}
          dataInvalidMessage={'Account Holder Name is required.'}
          forceHighlightErrors={this.state.highlightErrors}
        />

        <TextInput
          key={'accountNumber'}
          id={'accountNumber'}
          value={this.props.directDebitDetails.accountNumber}
          label={'Account Number*'}
          onChange={v => this.props.updateDirectDebitDetails(o => (o.accountNumber = v))}
          validator={Validator.isAccountNumber}
          dataInvalidMessage={'A valid 6-8 digit Account Number is required.'}
          forceHighlightErrors={this.state.highlightErrors}
        />

        <TextInput
          key={'sortCode'}
          id={'sortCode'}
          value={this.props.directDebitDetails.sortCode}
          label={'Sort Code*'}
          onChange={v => this.props.updateDirectDebitDetails(o => (o.sortCode = v))}
          validator={Validator.isSortcode}
          dataInvalidMessage={'A valid 6 digit Sort Code is required.'}
          forceHighlightErrors={this.state.highlightErrors}
        />
    
        {/* {this.renderPaymentFrequencySelect()} */}

        {/* {this.renderPaymentDaySelect()}  */}

        <SelectDateToDonate
          key={'dateToDonateInMonth'}
          id={'dateToDonateInMonth'}
          value={this.props.directDebitDetails.paymentDay.toString()}
          label={'I would like to donate on this date each month*'}
          dataInvalidMessage={'Date to donate in month is required.'}
          forceHighlightErrors={this.state.highlightErrors}
          validator={Validator.isNotEmpty}
          onChange={(date: string) => this.props.updateDirectDebitDetails(d => (d.paymentDay = date))}
        />
          <StartDateInput
            id={'startDonationFrom'}
            label={'Start my donation in* (MM/YY)'}
            value={this.props.directDebitDetails.startDonationFrom}
            forceHighlightErrors={this.state.highlightErrors}

            onChange={(date: { month: string; year: string; isValid: number; }) => {
            this.setState({ startDateValid: date.isValid });
            this.props.updateDirectDebitDetails(d => (d.startDonationFrom = date));
            }}
          />
          <div className="errorMessage margin-top-minus-3per">
            <span>{validStartDate ? '' : 'Start donation should not be of back date'}</span>
          </div>
        <Row>
          <div className="col s2">
            {this.props.ddType !== 'SEPA' ?
            <img src={require('../../../images/directdebitlogo.png')} width="100%" />
            : <img src={require('../../../images/SepaLogoEN.jpg')} width="100%" />
            }
          </div>
            
          <div className="col s10 directdebit-statement">
            Originator ID: {this.props.config.originatorsId} <br />
            {/* Payment will appear on your statement as{' '}
            {this.props.config.paymentAppearsAs} */}
          </div>
        </Row>
        <Divider />
        <Row>
          <div className="col s12 m7 sidePane">
            <b>
              You will be donating
              {' '}{pSymbol}
              {StringFormatter.numberAsCurrency(
                this.props.annualPaymentAmountPence
              )}{' '}
              per month.</b>
              <br/> You will be able to confirm the details on the next page.
            <br />
            {/* Paying{' '}
            {
              PaymentFrequency[this.props.directDebitDetails.paymentFrequency]
            }{' '}
            in installments of:&nbsp; {pSymbol}
            {StringFormatter.numberAsCurrency(
              Math.ceil(
                this.props.annualPaymentAmountPence / this.frequencyDivider()
              )
            )} */}
          </div>
          <div className="col s12 m7 lg7 xl7 sidePane">
            <br />
            {ReactHtmlParser(this.props.footerText ? this.props.footerText : '')}
          </div>
          <div className="submission-block col s12 m5 sidePane">
            <a className={submitBtnClass} onClick={this.handleSubmit}>
              {this.props.config.buttonText
                ? this.props.config.buttonText
                : 'View Summary'}
            </a>
          </div>
        </Row>
      </>
    );
  }
}

export { PaymentFrequency};
export default DirectDebitPaymentForm;



// WEBPACK FOOTER //
// ./src/MakeDonation/SignupJourney/PaymentForms/DirectDebitPaymentForm.tsx